<template>
  <div>
    <h1 class="text-xl">收藏夹</h1>
    <hr class="my-4">

    <SpaceOpener>
      <div v-if="!$asyncComputed.entries.updating">
        <table v-if="entries.length" class="ui very basic compact table filelist nowrap">
          <tbody>
            <EntryRow v-for="e in entries"
                      :space="space" :entry="e"
                      :key="e.obj_id"
                      :checked="e.checked"
                      :hide_checkbox="true"
                      :hide_check_background="true"
                      :show_path="true"
                      readonly="true"
                      fav_mode="true"
                      @click="handle_click(e)"
                      @goto="open(e)"
                      @download="download(e)"/>
          </tbody>
        </table>
        <div v-else class="ui message">
          还没有收藏的文件
        </div>
        <FilePreviewModal id="file-preview" ref="filePreview" @download="download($event)"/>
      </div>
      <Placeholder v-else>
      </Placeholder>
    </SpaceOpener>
  </div>
</template>

<script>
import EntryRow from '../components/entry-row';
import Placeholder from '../components/placeholder';
import SpaceOpener from '../components/space-opener';
import FilePreviewModal from '../components/file-preview-modal'

export default {
  name: 'FavsPage',
  props: [],
  components: {
    EntryRow,
    Placeholder,
    SpaceOpener,
    FilePreviewModal,
  },
  data: function () {
    return {
    };
  },
  computed: {
    space() {
      return this.$store.state.space;
    },
    favs() {
      return this.$store.state.favs;
    },
  },
  asyncComputed: {
    async entries() {
      var entries = [];
      for (var path of this.favs.keys()) {
        var e = await this.space.fetch(path);
        if (e) {
          e.is_fav = true;
          entries.push(e);
        } else {
          // TOOD: clean up deleted entries
        }
      }
      entries.sort(this.cmp_entry.bind(this));
      return entries;
    },
  },
  methods: {
    show_preview(e) {
      this.$refs.filePreview.reload(e)
      this.show_modal("file-preview");
    },
    cmp_entry(a, b) {
      if (a.isdir != b.isdir) {
        return a.isdir ? -1 : 1;
      }
      return a.name.localeCompare(b.name);
    },
    handle_click(e) {
      if (e.isdir) {
        this.enter(e);
      } else {
        this.show_preview(e);
      }
    },
    enter(e) {
      this.$router.push({
        name: 'files',
        query: {
          path: e.path,
        }
      });
    },
    open(e) {
      console.log("open", e);
      this.$router.push({
        name: 'files',
        query: {
          path: this.space.dirname(e.path),
          selected: e.name,
        }
      });
    },
    download(e) {
      this.$store.commit("download", {
        entries: [e],
      });
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

